import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import { formatAmount } from 'src/utils/formatAmout';
import MoreMenu from 'src/components/MoreMenu/MoreMenu';
import DocumentViewerDialog from 'src/components/DocumentViewer/DocumentViewerDialog';
import { SantanderClabeActions } from 'src/utils/constants/clients';
import DescriptionIcon from '@mui/icons-material/Description';

const DomiciledCollectionReportsRow = ({
  id,
  date,
  modality,
  totalAmount,
  totalFailedAmount,
  totalAttemptedAmount,
  excelReport,
  rawReport
}) => {
  const [openOption, setOpenOption] = useState('');

  const handlePreviewRaw = () => {
    setOpenOption(SantanderClabeActions.RAW_SANTANDER_PAYMENT_REPORT);
  };

  const handlePreviewExcel = () => {
    setOpenOption(SantanderClabeActions.EXCEL_SANTANDER_PAYMENT_REPORT);
  };

  const handleCloseDialog = () => {
    setOpenOption('');
  };

  const handleClickMore = action => {
    switch (action) {
      case SantanderClabeActions.RAW_SANTANDER_PAYMENT_REPORT:
        handlePreviewRaw();
        break;
      case SantanderClabeActions.EXCEL_SANTANDER_PAYMENT_REPORT:
        handlePreviewExcel();
        break;
      default:
        break;
    }
  };

  const getMoreMenuOptions = useCallback(() => {
    const options = [];
    if (rawReport) {
      options.push({
        name: SantanderClabeActions.RAW_SANTANDER_PAYMENT_REPORT,
        label: 'COMMON.RAW_SANTANDER_PAYMENT_REPORT',
        icon: <DescriptionIcon />
      });
    }

    if (excelReport) {
      options.push({
        name: SantanderClabeActions.EXCEL_SANTANDER_PAYMENT_REPORT,
        label: 'COMMON.EXCEL_SANTANDER_PAYMENT_REPORT',
        icon: <DescriptionIcon />
      });
    }

    return options;
  }, [rawReport, excelReport]);

  return (
    <>
      <TableRow>
        <TableCell align="center">
          {date ? momentLocalTimezone(date).format('DD-MMM-YY') : '-'}
        </TableCell>
        <TableCell align="center">
          {modality || '-'}
        </TableCell>
        <TableCell align="center">
          {totalAmount ? formatAmount(totalAmount) : '-'}
        </TableCell>
        <TableCell align="center">
          {totalFailedAmount ? formatAmount(totalFailedAmount) : '-'}
        </TableCell>
        <TableCell align="center">
          {totalAttemptedAmount ? formatAmount(totalAttemptedAmount) : '-'}
        </TableCell>
        <TableCell align="right">
          <MoreMenu
            deleteDisabled
            editDisabled
            key={id}
            options={getMoreMenuOptions()}
            handleClickOption={handleClickMore}
          />
        </TableCell>
      </TableRow>
      {rawReport && (
        <DocumentViewerDialog
          open={
            openOption === SantanderClabeActions.RAW_SANTANDER_PAYMENT_REPORT
          }
          onClose={handleCloseDialog}
          documentUrl={rawReport.documentUrl}
          fileName={`cobranza_domiciliada_${id}-${date}.txt`}
        />
      )}
      {excelReport && (
        <DocumentViewerDialog
          open={
            openOption === SantanderClabeActions.EXCEL_SANTANDER_PAYMENT_REPORT
          }
          onClose={handleCloseDialog}
          documentUrl={excelReport.documentUrl}
          fileName={`cobranza_domiciliada_${id}-${date}.xlsx`}
        />
      )}
    </>
  );
};

DomiciledCollectionReportsRow.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  modality: PropTypes.string,
  totalAmount: PropTypes.number,
  totalFailedAmount: PropTypes.number,
  totalAttemptedAmount: PropTypes.number,
  excelReport: PropTypes.object,
  rawReport: PropTypes.object
};

export default DomiciledCollectionReportsRow;

